import { css } from 'lit';

export const appRootStyles = css`
  :host {
    display: block;
  }

  .doc-container {
    max-width: var(--doc-max-width, 740px);
    margin: 0 auto;
    padding: 2.5rem 1.5rem;
    min-height: 100vh;
  }
`;
